export class ChatHistoryObject {
    limit = 0;
    page = 0;
    results: chatHistory[] = [new chatHistory()];
    totalPages = 0;
    totalResults = 0;
}

export class chatHistory {
    createdAt = '';
    title = '';
    updatedAt = '';
    user = '';
    id = '';
    description = '';
    listening = false;
    refId = '';
}

export class messages {
    limit = 0;
    page = 0;
    results: message[] = [];
    totalPages = 0;
    totalResults = 0;
    type: 'NEW' | 'OWNER' | 'FOLLOWER' = 'NEW';
    chatId = '';
}

export class message {
    chat = '';
    content = '';
    createdAt = '';
    id = '';
    media = [];
    role = '';
    updatedAt = '';
    questionRef = '';
    listening = false;
    refId = '';
    sources: Source[] = [];
    route?: string;
    contentBlocks?: any[];
    isBlocks = false;
    reaction?: string;
    separation?: string;
}

export interface chat {
    answer: string,
    question: string,
    loading: boolean,
    listening?: boolean,
    id: string;
    refId?: string;
    sources?: Source[] | any;
    route?: string;
    answerId?: string;
    contentBlocks?: any[];
    isBlocks?: boolean;
    reaction?: string;
    separation?: string;
    answerProcessing?: boolean;
    showProcessingText?: boolean;
}
export class AskQuestionModel {
    chatId = '';
    clientDateTime = new Date();
    textQuestion = '';
    audioQuestion = '';
    mediaKeys: any[] = [];
    regenerate = false;
    processType? = '';
    clientLocation? = '';
    holeNumber? = 0;
    courseId? = '';
    behaviour?: 'clicked' | 'ask' = 'ask';
    separation?: string;
    showProcessingText?: boolean = false;
}
export class ChatResponseModel {
    clientSocketId = '';
    data: any = '';
    event = '';
    error = '';
    source = '';
}
export class Source {
    _id = '';
    date = '';
    infoTitle = '';
    sourceTitle = '';
    url = '';
    image = '';
    source_title = '';
    info_title = '';
    title = '';
}

export class Topic {
    amount = 0;
    name = '';
    topic = '';
}

export class langAndCaddy{
    caddy!: caddyChat;
    language!: caddyLang
}

export interface caddyChat {
    name: string, 
    id: string, 
    personality: string, 
    code: string
}
export interface caddyLang {
  name: string, 
  id: string
}